module.exports = __webpack_public_path__ + "static/img/menu-ptips@2x.c61c184.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-ptips@2x.png
// module id = 60
// module chunks = 0